import React, { useState, useEffect, useRef } from "react";
import jwtDecode from "jwt-decode";
import ChatServices from "../services/chat.services";
import { getCurrentTimeWithAMPM } from "../helpers/DateTimeFormatter";
import { useLocation } from "react-router";
import { CHAT_API_BASE_URL } from '../../src/config';
import Footer from "../footer/footer";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SellerChatPage = () => {
  const location = useLocation();
  const sellerResponse = location.state?.data || {}; // Default to an empty object

  const [messages, setMessages] = useState([]);
  const [textMessage, setTextMessage] = useState("");
  const token = localStorage.getItem("user");
  const decoded = token ? jwtDecode(token) : null;
  const UserId = decoded.sub;
  const userName = decoded.name;
  const imageUrl = decoded.image_url || "./img/chat.png";
  const containerRef = useRef(null);

  const stompClientRef = useRef(null);
  const isConnecting = useRef(false);

  const connect = () => {
    if (isConnecting.current) return;
    if (stompClientRef.current && stompClientRef.current.connected) return;

    isConnecting.current = true;
    const Stomp = require("stompjs");
    var SockJS = require("sockjs-client");
    const socket = new SockJS(CHAT_API_BASE_URL);
    const client = Stomp.over(socket);

    client.debug = null; // Disable noisy logs

    const onConnectedLocal = () => {
      isConnecting.current = false;
      stompClientRef.current = client; // Only update ref once connected
      client.subscribe(
        "/user/" + UserId + "/queue/messages",
        onMessageReceived
      );
    };

    const onErrorLocal = (err) => {
      isConnecting.current = false;
      console.error("STOMP connection error:", err);
    };

    client.connect({}, onConnectedLocal, onErrorLocal);
  };

  const onMessageReceived = (msg) => {
    const message = JSON.parse(msg.body);

    if (String(message.senderId) !== String(UserId)) {
      setMessages((prevMessages) => {
        const alreadyExists = prevMessages.some((item) => item.id === message.id);
        if (alreadyExists) return prevMessages;
        return [...prevMessages, message];
      });
      setTimeout(() => {
        scrollToBottom();
      }, 500);
    }
  };

  const scrollToBottom = () => {
    // Scroll to the bottom of the container
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  };
  const sendMessage = () => {
    if (textMessage.trim() === "") return;

    if (stompClientRef.current && stompClientRef.current.connected) {
      const chatMessage = {
        senderId: Number(UserId),
        senderName: userName,
        recipientId: Number(sellerResponse?.userResponse?.id || sellerResponse?.id),
        recipientName: sellerResponse?.userResponse?.name || sellerResponse?.name,
        content: textMessage,
        timestamp: new Date(),
        productId: Number(sellerResponse?.id || 0),
        productTitle: sellerResponse?.title || "",
      };
      stompClientRef.current.send("/app/chat", {}, JSON.stringify(chatMessage));
      setMessages([...messages, chatMessage]);
      setTextMessage("");
      setTimeout(() => {
        scrollToBottom();
      }, 1000);
    } else {
      if (isConnecting.current) {
        toast.info("Connecting to chat... please wait.", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        });
      } else {
        toast.warning("Connection lost. Trying to reconnect...", {
          position: toast.POSITION.TOP_RIGHT,
        });
        connect();
      }
    }
  };



  const openMessagesHandler = async () => {
    let senderId = Number(UserId);
    let recipientId = Number(sellerResponse?.userResponse?.id || sellerResponse?.id);
    let productId = Number(sellerResponse?.id || 0);

    try {
      let res = await ChatServices.getMessages(senderId, recipientId, productId);
      setMessages(res.data.messagesList || res.data);
    } catch (error) {
      return error;
    }
  };



  useEffect(() => {
    // Debugging email flow
    console.log("Logged-in User (Sender) Details:", decoded);
    console.log("Recipient (Seller/Buyer) Email:", sellerResponse?.email);

    connect();
    openMessagesHandler();

    return () => {
      if (stompClientRef.current) {
        stompClientRef.current.disconnect();
      }
    };
  }, []);

  return (
    <>
      {/* <!-- -------------Chat-by-user-admin-start------ --> */}

      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <ul className="nav nav-tabs" id="myTab" role="tablist">
              <li className="nav-item tabs-design" role="presentation">
                <button
                  className="nav-link  "
                  id="messages-tab"
                  data-toggle="tab"
                  data-target="#messages"
                  type="button"
                  role="tab"
                  aria-controls="messages"
                  aria-selected="false"
                >
                  Selling
                </button>
              </li>
            </ul>

            {/* <!-- Tab panes --> */}
            <div
              className="tab-pane "
              id="messages"
              role="tabpanel"
              aria-labelledby="messages-tab"
            >
              <div
                className="row"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <div className="col-lg-6 my-3">
                  <div className="seller-chat-box">
                    <div className="chat-show-box">
                      <div className="user-name">
                        <div
                          className="msg-img"
                          style={{ backgroundImage: `url(${sellerResponse.imageUrl || "./img/chat.png"})` }}
                        ></div>
                        <h3 className="main-user-ct">{sellerResponse?.name}</h3>
                      </div>
                      <div className="user-detail">
                        <a href={`tel:${sellerResponse?.mobile}`}>
                          <i className="fa fa-phone"></i>
                        </a>
                        <a href={`mailto:${sellerResponse?.email}`}>
                          <i className="fa fa-envelope"></i>
                        </a>
                      </div>
                    </div>
                    <div className="chat-message" ref={containerRef}>
                      {messages?.map((item, index) => (
                        <div
                          key={index}
                          className={`msg ${item.senderId === Number(UserId)
                            ? "right-msg"
                            : "left-msg"
                            } mt-3`}
                        >
                          <div
                            className="msg-img"
                            style={{ backgroundImage: item.senderId === Number(UserId) ? `url(${imageUrl})` : `url(${sellerResponse.imageUrl})` }}
                          ></div>

                          <div className="msg-bubble">
                            <div className="msg-info">
                              <div className="msg-info-time">
                                {getCurrentTimeWithAMPM(item.timestamp)}
                              </div>
                            </div>

                            <div className="msg-text">{item.content}</div>
                          </div>
                        </div>
                      ))}
                      <div className="msger-inputarea">
                        <input
                          type="text"
                          className="msger-input"
                          placeholder="Enter your message..."
                          data-last-active-input=""
                          value={textMessage}
                          onChange={(e) => setTextMessage(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              sendMessage();
                            }
                          }}
                        />
                        <button
                          onClick={sendMessage}
                          type="button"
                          className="msger-send-btn"
                        >
                          Send
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SellerChatPage;
